<app-back-header-atom
  icon="arrow-left"
  [text]="'validate-shared-order.title' | translate"
  [textColor]="textColor()"
  [backgroundColor]="backgroundColor()"
  (navigationClick)="back()"
></app-back-header-atom>
